export default __webpack_public_path__ + "static/media/rar.bd318b2a.svg";